let _this =  {


	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/
	$dom: {
		label: $('.franli-block-product-categories__filters-item'),
        tabs: $('.franli-block-product-categories__items')
    },

    vars: {
	},

	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function () {
        _this.bind();
    },
    bind: function() {
        _this.$dom.label.on('click', _this.tabs);
        $(document).ready(function() {
            _this.$dom.tabs.first().addClass('active');
        });
    },

    tabs: function() {
        let currentLabel = $(this);
        let labelSlug = currentLabel.data('cat-slug');

        if(currentLabel.hasClass('active')) return;

          $.each(_this.$dom.tabs, function(key, tab) {
                let tabSlug = $(tab).data('cat-slug');

                if(tabSlug === labelSlug) {
                    _this.$dom.tabs.removeClass('active');
                    _this.$dom.label.removeClass('active');
                    currentLabel.addClass('active');
                    $(tab).addClass('active');
                }
          });
    }

};

export default _this;